import { IconButton, ShareIcon } from "@au-schein-de/au-ui-library";
import { createLogger } from "@dransay/logger/browser";
import { useCallback } from "react";

const logger = createLogger({ service: "platform" });

import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../hooks/use-is-mobile";

type ShareButtonProps = {
	title: string;
	text?: string;
	url: string;
};

export function ShareButton({ title, text, url }: ShareButtonProps) {
	const { t } = useTranslation("common");

	const handleShare = useCallback(async () => {
		if (!navigator.share) {
			return;
		}

		try {
			await navigator.share({
				title,
				text,
				url,
			});
		} catch (error) {
			if (error instanceof Error && error.name !== "AbortError") {
				logger.error({ error }, "Error sharing");
			}
		}
	}, [title, text, url]);

	const isMobile = useIsMobile();

	if (!isMobile) {
		return null;
	}

	return (
		<IconButton
			type="button"
			aria-label={t("share")}
			icon={<ShareIcon size={6} colorToken="gray-700" />}
			shape="circle"
			color="gray"
			className="size-11 min-h-11 min-w-11 bg-white border-0 shadow-none hover:bg-white active:bg-white"
			onClick={handleShare}
			data-testid="product-share-button"
		/>
	);
}
